import { Box, Typography } from '@mui/material';

const SectionHeader = ({ icon: Icon, title }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        mb: 3,
      }}
    >
      {Icon && <Icon sx={{ fontSize: 28, color: '#212121' }} />}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: '#212121',
          fontSize: { xs: '1.25rem', sm: '1.5rem' },
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default SectionHeader;